// src/Pages/Landing/JoyrideJarvenpaaLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyrideJarvenpaaLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Järvenpää"
      maakunta="Uusimaa"
      nearbyAreas={[
        "Kerava",
        "Tuusula",
        "Vantaa",
        "Sipoo",
        "Helsinki",
        "Mäntsälä"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Järvenpäässä ja lähialueilla tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Järvenpää sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, syntymäpäiville, yritysjuhliin, pikkujouluihin ja yksityistilaisuuksiin, kun juhliin halutaan energinen livebändi."
      logisticsText="Bilebändi Joyride toimii Keski-Uudeltamaalta käsin, joten Järvenpää on bändille luontevaa lähialuetta. Oma kuljetus, oma äänentoisto ja valotekniikka helpottavat keikan toteutusta etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}